import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { WalletSwap } from '@root/features/trade/wallet-swap/ui/common'
import { walletsManagerModelAtom } from '@root/pages/wallet-manager/atoms'

import { WalletDetailsSection } from '../wallet-details-section'

import type { WalletModel } from '@root/entities/wallet'

type WalletsDetailsSwapProps = {
  wallet: WalletModel
}

export const WalletsDetailsSwap: React.FC<WalletsDetailsSwapProps> = ({
  wallet,
}) => {
  const { t } = useTranslation()
  const [model] = useAtom(walletsManagerModelAtom)
  const clearSelectedWallet = useAction(model.clearSelectedWallet)

  return (
    <Root title={t('swap')} onClose={clearSelectedWallet}>
      <WalletSwap wallet={wallet} />
    </Root>
  )
}

const Root = styled(WalletDetailsSection)`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  min-height: 0;

  background: var(--appearance-1);

  & ${WalletDetailsSection.Content} {
    display: grid;
    grid-template-rows: minmax(0, 1fr);
    min-height: 0;

    padding-inline: 12px;
    padding-block: 10px;
  }
`
